<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="acceptToUpdate"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionAcademyConfigurationModalEdit.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p>
          {{ $t('mEditionAcademyConfigurationModalEdit.message.first') }}
        </p>
        <p class="font-size-small">
          {{ $t('mEditionAcademyConfigurationModalEdit.message.second') }}
        </p>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionAcademyConfigurationModalEdit.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAcademyConfigurationModalEdit',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionAcademyConfigurationModalEdit.buttonPrimary'),
        class: 'a-button-academy-primary',
        sending: false,
        type: 'submit'
      }
    }
  },

  methods: {
    acceptToUpdate () {
      this.$modal.updateData('updateAcademia')
      this.$modal.closeModal()
    }
  }
}
</script>
